/* eslint no-unused-expressions: 0 */

import "typeface-lora";
import "typeface-source-sans-pro";
import "typeface-rubik";
import "../shared/css/globalStyles";

import { FAB, Footer, SEO } from "components";
import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";
import { reset, theme } from "styles";

import PropTypes from "prop-types";
import { ThemeProvider } from "emotion-theming";
import { injectGlobal } from "emotion";

injectGlobal`
  ${reset}

  h1, h2, h3, h4, h5, h6 {
    color: ${theme.colors.black};
  }
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    color: ${theme.colors.greyDarker};
    background-color: ${theme.colors.white};
  }
  ::selection {
    color: ${theme.colors.white};
    background-color: ${theme.colors.darkBlue};
  }
  a {
    color: ${theme.colors.darkBlue};
    transition: all ${theme.transitionDuration} ease-in-out;
    text-decoration: none;
    font-weight: 700;
    font-style: italic;
    &:hover, &:focus {
      text-decoration: underline;
    }
  }
  @media (max-width: ${theme.breakpoints.m}) {
    html {
      font-size: 16px !important;
    }
  }
  @media (max-width: ${theme.breakpoints.s}) {
    h1 {
      font-size: 2.369rem !important;
    }
    h2 {
      font-size: 1.777rem !important;
    }
    h3 {
      font-size: 1.333rem !important;
    }
    h4 {
      font-size: 1rem !important;
    }
    h5 {
      font-size: 0.75rem !important;
    }
    h6 {
      font-size: 0.563rem !important;
    }
  }
`;

const PureLayout = ({ children, data }) => (
  <ThemeProvider theme={theme}>
    <>
      <SEO />
      {children}
      {/* <FAB /> */}
      <Footer socialMedia={data.prismicHomepage.data}>
        <div
          dangerouslySetInnerHTML={{
            __html: data.prismicHomepage.data.footer.html
          }}
        />
      </Footer>
    </>
  </ThemeProvider>
);

class Layout extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query LayoutQuery {
            prismicHomepage {
              data {
                footer {
                  html
                }
                linkedin {
                  url
                }
                twitter{
                  url
                }
                instagram {
                  url
                }
              }
            }
          }
        `}
        render={data => <PureLayout {...this.props} data={data} />}
      />
    );
  }
}

export default Layout;

PureLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
  data: PropTypes.object.isRequired
};
